import { render, staticRenderFns } from "./SummaryFilter.vue?vue&type=template&id=1f7e5410&scoped=true&"
import script from "./SummaryFilter.vue?vue&type=script&lang=js&"
export * from "./SummaryFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7e5410",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/summary/SummaryFilter.vue
// module id = 1555
// module chunks = 0